@if (!breadcrumbStore.hidden() && breadcrumbStore.navigationPaths().length > 0) {
  <div class="bg-card surface-default flex w-full flex-0 flex-row items-center border-b px-4 py-2">
    @if (breadcrumbStore.navigationPaths().length > 1) {
      <div class="pr-2">
        <button (click)="goBack()" color="accent" mat-icon-button>
          <mat-icon class="mat-icon-no-color icon-size-5"> arrow_back </mat-icon>
        </button>
      </div>
    }
    <div class="min-w-0 flex-1">
      @if (breadcrumbStore.navigationPaths().length === 1) {
        <span class="truncate text-3xl leading-10 font-extrabold tracking-tight">{{
          breadcrumbStore.navigationPaths()[0].label
        }}</span>
      } @else if (breadcrumbStore.navigationPaths().length) {
        <div class="flex flex-wrap items-center font-medium">
          @for (
            navigationPath of breadcrumbStore.navigationPaths();
            track navigationPath.path || $index;
            let index = $index
          ) {
            <div [class.ml-0]="index === 0" class="ml-1 flex items-center whitespace-nowrap">
              @if (index > 0) {
                <mat-icon class="mat-icon-no-color text-secondary icon-size-5">chevron_right</mat-icon>
              }

              @if (navigationPath.path) {
                @if (navigationPath.avatar) {
                  <aura-avatar
                    class="px-1"
                    [label]="navigationPath.label"
                    [srcImage]="navigationPath.avatar.srcImage"
                    [size]="'3xs'"
                  />
                }

                @if (index === breadcrumbStore.navigationPaths().length - 1) {
                  <span class="whitespace-nowrap">
                    {{ navigationPath.label }}
                  </span>
                } @else {
                  <button (click)="goTo(navigationPath.path)" class="cursor-pointer whitespace-nowrap">
                    {{ navigationPath.label }}
                  </button>
                }
              }
            </div>
          }
        </div>
      }
    </div>
    <div class="flex flex-row gap-x-6">
      @if (options()?.buttons?.length) {
        @for (button of options()?.buttons; track $index) {
          <div>
            <button
              [disabled]="button.disabled"
              [color]="button.color"
              (click)="toggleButtonAction(button.action)"
              mat-button
            >
              <span class="hidden px-1 md:block">{{ button.label }}</span>
              @if (button.icon) {
                <mat-icon>{{ button.icon }}</mat-icon>
              }
            </button>
          </div>
        }
      }
      @if (options()?.refresh) {
        <button
          [disabled]="refreshStateDisabled()"
          (click)="toggleRefreshAction()"
          color="primary"
          mat-stroked-button
        >
          <span class="hidden px-1 md:block">{{ 'members_refresh' }}</span>
          <mat-icon>refresh</mat-icon>
        </button>
      }
      @if (options()?.drawer) {
        <button (click)="toggleDrawerAction()" color="accent" mat-icon-button>
          <mat-icon>menu</mat-icon>
        </button>
      }
    </div>
  </div>
}
